import {  Row, Col } from "react-bootstrap";
import Timeline from "../Wallet_Profile/Timeline/Timeline";
import ProfileSection from "../Wallet_Profile/Timeline/Profilesection";
import BackArrow from "../../components/backArrow";
const SeekarProfile = () => {
  return (
    <Row>
      <div className="screenHeight d-lg-flex justify-content-center  p-3">
       <Col lg="1" md="1" sm="1" xs="1" className="h-lg-100">
       <BackArrow />
       </Col>
 
        <Col lg="6" md="12" sm="12" xs="12" className="h-lg-100">
          <ProfileSection />
        </Col>
  
        <Col lg="4" md="12" sm="12" xs="12" className="h-lg-100">
          <Timeline />
        </Col>
      </div>
    </Row>
  );
};

export default SeekarProfile;
